import { render, staticRenderFns } from "./position-select.vue?vue&type=template&id=2656d8df&scoped=true"
import script from "./position-select.vue?vue&type=script&lang=js"
export * from "./position-select.vue?vue&type=script&lang=js"
import style0 from "./position-select.vue?vue&type=style&index=0&id=2656d8df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656d8df",
  null
  
)

export default component.exports